import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MAIN_NAV } from './navigation';

const TITLES: Record<string, string> = {
  ...Object.fromEntries(MAIN_NAV.map(({ to, title }) => [to, title])),
  '/login': '로그인',
  '/register': '회원가입',
  '/privacy': '개인정보 처리방침',
  '/data-deletion': '데이터 삭제 안내',
};

export function RouteEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = `${TITLES[pathname] ?? '콘텐츠 스튜디오'} · Auto Threads`;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}
